'use client'

import * as React from 'react'
import { ChevronLeft } from 'lucide-react'

import { Button } from '@ui/web/components'
import cn from '@config/tailwind/cn'

export interface NotFoundProps {
  className?: string
  style?: React.CSSProperties
}

export function NotFound({ className, style }: NotFoundProps) {
  return (
    <div
      className={cn(
        'srd:w-dvw srd:h-dvh srd:overflow-hidden srd:flex srd:items-center srd:justify-start srd:select-none',
        className,
      )}
      style={style}
    >
      <div className='srd:text-left srd:flex srd:flex-col srd:items-start srd:justify-center srd:gap-y-8 srd:px-2 srd:md:ml-20 srd:sm:ml-4 srd:ml-0'>
        <h1 className="srd:font-bold srd:text-5xl srd:text-main-red-100 srd:font-['Raleway']">404</h1>

        <p className='srd:md:text-2xl srd:text-xl'>Halaman yang kamu tuju gaada nih</p>

        <p className='srd:md:text-xl srd:text-lg'>Coba cek ulang URL nya :)</p>

        <div className='srd:flex srd:gap-2 srd:flex-wrap'>
          <Button
            className='srd:w-32 srd:bg-neutrals-white srd:rounded-2xl srd:text-main-blue-100 srd:border-main-blue-100 srd:border'
            onClick={() => {
              window.history.back()
            }}
          >
            <ChevronLeft className='srd:mr-2 srd:h-4 srd:w-4' />
            Kembali
          </Button>

          <Button className='srd:w-fit srd:bg-main-blue-100 srd:rounded-2xl srd:text-neutrals-white' asChild>
            <a href='/'>Ke Halaman Utama</a>
          </Button>
        </div>
      </div>
    </div>
  )
}
